<template>
  <div class="finder_wrapper">
    <b-input placeholder="검색어를 입력하세요" v-model="srhtext" />
    <b-button variant="success" @click="search"> 검색</b-button>
  </div>
</template>

<script>
export default {
  computed: {
    srhtext: {
      get() {
        return this.$store.state.srhtext;
      },
      set(val) {
        this.$store.state.srhtext = val;
      },
    },
  },
  methods: {
    search() {
      // alert("search");
      let book_id = this.$store.state.book_id;
      this.$store.dispatch("loadQuestionList", book_id);
    },
  },
};
</script>


<style lang="scss" scoped>
.finder_wrapper {
  display: flex;
  input {
    // width: 80%;
  }
  button {
    width: 80px;
    margin-left: 10px;
    margin-bottom: 20px;
  }
}
</style>